import { useEffect, useRef } from 'react';
import { IUserDropdown } from 'interfaces/components/userDropdown';
import ButtonWithIcon from 'components/ButtonWithIcon';
import DownIcon from 'assets/icons/down.svg';
import DownWhiteIcon from 'assets/icons/down-white.svg';
import { useDarkMode } from 'utils/hooks/DarkMode';

const UserDropdown = ({ isOpen, onToggle, userName, items }: IUserDropdown) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const isDarkMode = useDarkMode('(prefers-color-scheme: dark)');

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        onToggle();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onToggle]);

  return (
    <div className='relative' ref={dropdownRef}>
      {/* User name and dropdown trigger */}
      <div
        className='flex items-center gap-2 cursor-pointer'
        onClick={onToggle}
      >
        <span className='text-base font-semibold'>{userName}</span>
        <img
          src={isDarkMode ? DownWhiteIcon : DownIcon}
          alt='dropdown'
          className={`w-5 h-5 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </div>

      {/* Dropdown menu */}
      {isOpen && (
        <div className='absolute right-0 p-4 flex flex-col gap-4 top-full mt-4 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-400 dark:border-gray-700 z-50'>
          {items.map((item, index) => (
            <ButtonWithIcon
              key={index}
              prefixIcon={item.icon}
              prefixIconStyle='w-5 h-5 mr-1'
              prefixIconAlt={item.label}
              label={item.label}
              className='flex items-center w-full cursor-pointer'
              textStyle='text-base font-light hover:text-green-700 dark:hover:text-green-300'
              onClick={item.onClick}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default UserDropdown;
